module.exports = __webpack_public_path__ + "static/media/logo_google.119054d8.svg";